export enum eProductStatus {
    DRAFT = 0,
    ACTIVE = 1,
    INACTIVE = 2
}